// composables/useCareerPage.ts
import SeoInjector from '@/composables/helpers/seoInjector'
import type { ISeoMetadataFields } from '@/types/contentful'
import { useContentfulFetch } from '@/composables/useContentfulFetch'

export const useCareerPage = async () => {
  const route = useRoute()
  const { getLastOffers } = useErecruiter()

  const key = `career-page-${route.path}`

  const setSeo = (data: ISeoMetadataFields) => {
    new SeoInjector(data).inject()
  }

  const { data } = await useAsyncData(key, async () => {
    try {
      const [content, offers] = await Promise.all([
        useContentfulFetch({
          url: '/api/v1/contentful/career',
          query: {
            contentModelOptions: {
              adapter: 'career',
              route: '/o-benefit-systems/kariera',
            },
          },
        }),
        getLastOffers(),
      ])

      return {
        content: content ?? null,
        offers: offers ?? [],
      }
    } catch (e) {
      console.error(e)
      return {
        content: null,
        offers: [],
      }
    }
  })

  return { data, setSeo }
}
